import { render, staticRenderFns } from "./LabelHtml.vue?vue&type=template&id=663f33fb"
import script from "./LabelHtml.vue?vue&type=script&lang=js"
export * from "./LabelHtml.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports